// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__zE45b","rootSuccess":"CompleteLink_rootSuccess__qpKr7","rootFailure":"CompleteLink_rootFailure__1ninI","isDisabled":"CompleteLink_isDisabled__1hQn6"};